<div [class]="'checkout-action-banner checkout-action-banner--' + color">
    <div class="checkout-action-banner__inner-container" [innerHTML]="content"></div>
</div>
